import * as React from "react";
import { useTranslation } from "react-i18next";
import { PlayerFragmentFragment } from "../../../graphql/PlayerFragment.generated";
import { PackOfferContentFragmentFragment } from "../../../graphql/ActivityFragment.generated";
import { usePackOffer } from "./usePackOffer";
import { OpenOfferButton } from "./OpenOfferButton";

export const PackOfferActivity = ({
  content,
  setRead,
}: {
  actor: PlayerFragmentFragment | null;
  content: PackOfferContentFragmentFragment;
  openProfile: () => void;
  setRead: () => void;
}) => {
  const { t } = useTranslation();
  const { open, fetching } = usePackOffer(content.offerId, setRead);

  return (
    <div>
      <strong className="block">{t("pack_offer.notification_title")}</strong>
      <div className="text-sm">{content.message}</div>
      <OpenOfferButton open={open} fetching={fetching} />
    </div>
  );
};
